const URL_REGEX_WITH_PROTOCOL = /(?:https?|ftp|mailto):\/?\/?[\S]+/g;
const URL_REGEX_WWW = /(?:www\.)[\S]+/g;
export default {
  install: function (Vue) {
    Vue.directive('strip-url', {
      twoWay: true,
      bind: (el,binding, vnode) => {
        this.handler = (e) => {
          if (el.value) {
            const original = e.target.value;
            e.target.value = e.target.value.replace(URL_REGEX_WITH_PROTOCOL, '').replace(URL_REGEX_WWW, '');
            if (original !== e.target.value) {
              vnode.elm.dispatchEvent(new CustomEvent('input'));
            }
          }
        };
        el.addEventListener('input', this.handler);
      },
      unbind: (el) => {
        el.removeEventListener('input', this.handler);
      }
    })
  }
}
